const generateTestId = (name) => ({ 'data-testid': name });

export default generateTestId;
